const paymentType = [
  { key: 1, value: 'Accounts Payable - Attorney fees' },
  { key: 2, value: 'Accounts Payable - Goods' },
  { key: 3, value: 'AP - Non - employee compensation' },
  { key: 4, value: 'Accounts Payable - Rents' },
  { key: 5, value: 'Dividends - Foreign Source' },
  { key: 6, value: 'Dividends - Ordinary(Private)', isPooled: true },
  { key: 7, value: 'Dividends - Ordinary(Public)' },
  { key: 8, value: 'Dividends - Qualified', isPooled: true },
  { key: 9, value: 'Fees - Borrow' },
  { key: 10, value: 'Fees - Contract' },
  { key: 11, value: 'Fees - Foreign Source' },
  { key: 12, value: 'Fees - Financial Services' },
  { key: 13, value: 'Fees - Loan Prepayment' },
  { key: 14, value: 'Gross Proceeds' },
  { key: 15, value: 'Interest - Bank Deposit' },
  { key: 16, value: 'Interest - Foreign Source' },
  { key: 17, value: 'Interest - Non - Portfolio', isPooled: true },
  { key: 18, value: 'Interest - Portfolio', isPooled: true },
  { key: 19, value: 'REIT - Dividends - Private', isPooled: true },
  { key: 20, value: 'REIT - Dividends - Public', isPooled: true },
  { key: 21, value: 'REIT - Long - Term Capital Gains', isPooled: true },
  { key: 22, value: 'REIT - Short - Term Capital Gains', isPooled: true },
  { key: 23, value: 'Return of Capital' },
  { key: 24, value: 'RIC - Dividends - Private', isPooled: true },
  { key: 25, value: 'RIC - Dividends - Public', isPooled: true },
  { key: 26, value: 'RIC - Long-Term Capital Gains', isPooled: true },
  { key: 27, value: 'RIC - Short-Term Capital Gains', isPooled: true },
  { key: 28, value: 'Swaps' },
  { key: 29, value: 'Ordinary ECI/Short-Term Capital Gains' },
  { key: 30, value: 'Collectibles Gains' },
  { key: 31, value: 'Unrecaptured Section 1250 Gains' },
  { key: 32, value: 'Section 1231 Gains/Qualified Dividend Income' },
  { key: 33, value: 'Publicly Traded Partnership Distributions', isPooled: true },
  { key: 34, value: 'Substitute Dividends - Ordinary(Public)', isPooled: true },
  { key: 35, value: 'Substitute Dividends - 871(m)', isPooled: true },
  { key: 36, value: 'Substitute Interest – Non-Portfolio' },
  { key: 37, value: 'Real Property Income' },
  { key: 38, value: 'Natural Resource Royalties', isPooled: true },
  { key: 39, value: 'Copyright Royalties', isPooled: true },
  { key: 40, value: 'Other Income' },
  { key: 41, value: 'Public Securities Royalties', isPooled: true },
  { key: 42, value: 'Partnership Gross Proceeds', isPooled: true },
  { key: 43, value: 'Substitute Dividends - 871(m) Gross Proceeds', isPooled: true },
  { key: 44, value: 'Original Issue Discount - Short-Term Non-Portfolio' },
  { key: 45, value: 'Original Issue Discount - Long-Term Non-Portfolio' },
  { key: 46, value: 'Original Issue Discount - Short-Term Portfolio' },
  { key: 47, value: 'Original Issue Discount - Long-Term Portfolio' },
  { key: 48, value: 'Substitute Interest - Non-Portfolio(Private)' },
  { key: 49, value: 'Substitute Dividends - Ordinary(Private)' },
];

paymentType.findByKey = (key) => {
  if (!key || key <= 0) {
    return null;
  }

  const code = paymentType.find(x => x.key === key);
  return code && code.value ? code.value : null;
};

export default paymentType;
